import { render } from "./Button.vue?vue&type=template&id=4f1491f8&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=4f1491f8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4f1491f8"

export default script